<template>
  <app-layout title="Заявки">
    <v-card height="100%" width="100%">
      <v-card-title>
        ЗАЯВКИ
      </v-card-title>
      <v-card-text>
        <v-btn
          @click="navigate('createBuyout')"
          flat>Оформить по номеру договора
        </v-btn>
        <v-data-table
          :headers="headers"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :loading="isLoading"
          :items="list"
          rows-per-page-text=""
          :rows-per-page-items="[{text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
        >
          <template slot="items" slot-scope="props">
            <td>{{ convertDate(props.item.date) }}<br>{{ props.item.btag }}</td>
            <td>{{ props.item.client && props.item.client.name }}<br>{{ props.item.client && props.item.client.phone }}</td>
            <td>{{ props.item.device && props.item.device.name }} {{ props.item.device && props.item.device.Capacity }}<br>{{ props.item.device && props.item.device.deviceId }}</td>
            <td>Цена: {{ props.item.price }} {{user.currency}}<br>Скидка: {{ props.item.discount && props.item.discount[0] ? props.item.discount[0] : 0 }} {{user.currency}}</td>
            <td>{{ statusById[props.item.status] || 'No  status' }}</td>
            <td>
              <v-btn
                v-if="props.item.status === 1 || props.item.status === 2"
                color="success"
                @click="startBuyout(props.item.btag)"
              >
                Оформить
              </v-btn>
              <v-btn v-if="props.item.status >= 3 && props.item.status != 12" color="info" :href="props.item.contract && props.item.contract[0]" target="_blank">Договор</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import AppLayout from '../components/AppLayout.vue';
import moment from 'moment';

export default {
  name: 'Orders',
  data: () => ({
    datePicker: {
      modal: false,
      menu: false,
      menu2: false,
    },
    // filters: {
    //   id: null,
    //   status: null,
    //   date_start: new Date().toISOString().substr(0, 10),
    //   date_end: new Date().toISOString().substr(0, 10),
    // },
    headers: [
      {
        text: 'Дата / Номер договора',
        value: 'id',
      },
      {
        text: 'Покупатель',
        value: 'client',
      },
      {
        text: 'Устройство / IMEI/SN',
        value: 'device',
      },
      {
        text: 'Стоимость / Доп.скидка',
        value: 'price',
      },
      {
        text: 'Статус',
        value: 'status',
      },
      {
        text: '',
        value: 'btn',
      },
    ],
  }),
  components: {
    AppLayout,
  },
  methods: {
    ...mapActions('orders', [
      'loadOrders',
    ]),
    filter() {
      this.loadOrders({
        filters: this.filters,
      });
    },
    convertDate(date){
      return moment(String(date)).format('DD.MM.YYYY hh:mm')

    },
    navigate(route) {
        if (this.$router.history.current.name != route) {
          this.$router.push({ name: route });
        }
      },
    startBuyout(id) {
        // this.$router.push({
        //   name: 'createBuyout',
        //   params: { id }
        // });
        this.$router.push({
          name: 'buy-phones',
          params: {
            btag: id
          }
        });
      },
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('orders', ['list', 'isLoading']),
    ...mapGetters('statuses', ['statusById']),
    pagination: {
      get() {
        return this.$store.getters['orders/pagination'];
      },
      set(data) {
        this.loadOrders(data);
      },
    },
  },
};
</script>
